module.exports = __webpack_public_path__ + "img/4.08df0eec.jpg";